import { useSignupProgressBar } from 'modules/auth/hooks/useSignupProgressBar'
import { ProgressBar } from 'modules/common/components/_ui/ProgressBar'

export const SignupFormProgressBar = () => {
  const { fill } = useSignupProgressBar()
  return <ProgressBar fill={fill} color="primary" />
}
